export const DailyRouteLeadingCountStatusStyles = `
    .bg-green {
      background-color: #C3E7C3;
    }
  }
`;
